import {
  SEASONAL_REQUEST, GET_SEASONAL_SUCCESS, ADD_SEASONAL_SUCCESS,
  UPDATE_SEASONAL_SUCCESS, DELETE_SEASONAL_SUCCESS, SEND_SEASONAL_SUCCESS,
  GET_SEASONAL_ORDERS_SUCCESS, UPSERT_SEASONAL_ORDER_SUCCESS,
  UPDATE_ORDER_STATUS_SUCCESS, SEASONAL_FLAG_OFF,
} from "../constant";

const initialState = {
  menus: [],
  orders: [],          // 현재 선택된 메뉴의 주문 목록
  selectedMenuId: null,
  loading: false,
  isMenuAdded: false,
  isMenuUpdated: false,
  isMenuDeleted: false,
  isSent: false,
};

export const seasonalMenuReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEASONAL_REQUEST:
      return { ...state, loading: true };
    case GET_SEASONAL_SUCCESS:
      return { ...state, loading: false, menus: action.payload };
    case ADD_SEASONAL_SUCCESS:
      return { ...state, menus: [action.payload, ...state.menus], isMenuAdded: true };
    case UPDATE_SEASONAL_SUCCESS:
      return {
        ...state,
        isMenuUpdated: true,
        menus: state.menus.map(m => m._id === action.payload._id ? action.payload : m),
      };
    case DELETE_SEASONAL_SUCCESS:
      return {
        ...state,
        isMenuDeleted: true,
        menus: state.menus.filter(m => m._id !== action.payload),
      };
    case SEND_SEASONAL_SUCCESS:
      return {
        ...state,
        isSent: true,
        menus: state.menus.map(m => m._id === action.payload._id ? action.payload : m),
      };
    case GET_SEASONAL_ORDERS_SUCCESS:
      return { ...state, orders: action.payload.orders, selectedMenuId: action.payload.menuId };
    case UPSERT_SEASONAL_ORDER_SUCCESS:
      return {
        ...state,
        orders: state.orders.some(o => o._id === action.payload._id)
          ? state.orders.map(o => o._id === action.payload._id ? action.payload : o)
          : [...state.orders, action.payload],
      };
    case UPDATE_ORDER_STATUS_SUCCESS:
      return {
        ...state,
        orders: state.orders.map(o => o._id === action.payload._id ? action.payload : o),
      };
    case SEASONAL_FLAG_OFF:
      return { ...state, isMenuAdded: false, isMenuUpdated: false, isMenuDeleted: false, isSent: false };
    default:
      return state;
  }
};
